export default "__VITE_ASSET__0A6E85cJ__"